// extracted by mini-css-extract-plugin
module.exports = {"mobileInput":"styles_mobileInput__Q1Vx_","bannedText":"styles_bannedText__2Rsyf","bannedInput":"styles_bannedInput__1T5To"};